// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1Y-2a","label":"Category_label__2Ps8j","content":"Category_content__gVIQ6","header":"Category_header__1Wu5G","location":"Category_location__1N7Mo"};